import type {
  AssistantID,
  TeacherAssistantBody,
  TeacherAssistantHistoryResponse,
  TeacherAssistantPromptBody,
  TeacherAssistantPromptResponse
} from '@/models/interface/aiChat';
import { ApiFactory, type ApiDataResponse, type ApiResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_CHATBOTTALK_BASE_URL;

export class AiChatService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 取得 當前語音角色
   */
  getAssistantVoice(): Promise<ApiDataResponse<AssistantID>> {
    return super.get(`Chats/VoiceSetting`);
  }
  /**
   * 建立 語音角色
   * @param voiceId - 語音角色 ID
   */
  createAssistantVoice(voiceId: AssistantID): Promise<ApiDataResponse<null>> {
    return super.post(`Chats/VoiceSetting`, null, {
      headers: {
        'Content-Type': 'application/json',
        disableGlobalLoading: true
      },
      params: { voiceId }
    });
  }
  /**
   * 取得 最近對話紀錄列表
   */
  getChatListHistory(): Promise<ApiDataResponse<TeacherAssistantHistoryResponse[]>> {
    return super.get(`Chats/TeacherAssistant/history`);
  }
  /**
   * 移除 最近對話紀錄列表
   */
  removeChatListHistory(): Promise<ApiResponse> {
    return super.deleteData(`Chats/TeacherAssistant/history`);
  }
  /**
   * 取得 AI 助教對話使用次數
   */
  getAITeacherAssistantDailyQuota(): Promise<ApiDataResponse<number>> {
    return super.get(`Users/AITeacherAssistantDailyQuota`);
  }
  /**
   * 建立 情境對話
   * @param body - 情境對話請求酬載
   */
  createTeacherAssistant(body: TeacherAssistantBody): Promise<ApiDataResponse<null>> {
    return super.post(`Chats/TeacherAssistant`, body, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }
  /**
   * 建立 文字對話
   * @param body - 文字對話請求酬載
   */
  createTeacherAssistantChat(
    body: TeacherAssistantPromptBody
  ): Promise<ApiDataResponse<TeacherAssistantPromptResponse>> {
    return super.post(`Prompts/TeacherAssistantChat`, body, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }
  /**
   * 建立 文字轉語音對話
   * @param voiceId - 語音角色 ID
   * @param body - 文字轉語音請求酬載
   */
  createSpeak(voiceId: AssistantID, body: string): Promise<{ data: ArrayBuffer }> {
    return super.post(`Prompts/Speak`, body, {
      headers: {
        'Content-Type': 'application/json',
        disableGlobalLoading: true
      },
      params: { voiceId },
      responseType: 'arraybuffer'
    });
  }
  /**
   * 建立 語音轉文字對話
   * @param body - 語音轉文字請求酬載
   * @param language - 語系代碼，預設為 2
   */
  createAudioToText(body: { file: Blob }, language: number = 2): Promise<ApiDataResponse<string>> {
    return super.post(`Prompts/AudioToText/${language}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        disableGlobalLoading: true
      },
      timeout: 30000
    });
  }
}
